module.exports = __webpack_public_path__ + "img/img_xmas2025.8f696668.png";